import { render, staticRenderFns } from "./Changepasswordwithotp.vue?vue&type=template&id=d59a4c90"
import script from "./Changepasswordwithotp.vue?vue&type=script&lang=js"
export * from "./Changepasswordwithotp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports